import { render, staticRenderFns } from "./MasterplanTags.vue?vue&type=template&id=2d2d7f4c&scoped=true&"
import script from "./MasterplanTags.vue?vue&type=script&lang=js&"
export * from "./MasterplanTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2d7f4c",
  null
  
)

export default component.exports